import React, { JSX } from "react";
import { useNavigate } from "react-router";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ListItemButton from "@mui/material/ListItemButton";

import { MenuItem } from "../types";

interface ActionMenuItemProps<T> {
  item: MenuItem<T>;
  row?: T;
}

const ActionMenuItem = React.memo(function ActionMenuItem<T>({
  item,
  row,
}: ActionMenuItemProps<T>) {
  const navigate = useNavigate();

  const { route, icon: Icon, name, action, bottomDivider } = item;

  const onClick = async () => {
    action && (await action(row));
    route && navigate(route);
  };

  return (
    <>
      <ListItemButton
        sx={{ m: 0, color: "#393939", alignItems: "left" }}
        onClick={onClick}
      >
        {Icon && <Icon />}
        <Typography variant="body2" sx={{ ml: 1.5 }} color="text.secondary">
          {name}
        </Typography>
      </ListItemButton>
      {bottomDivider && (
        <Box
          sx={{
            borderTop: "1px solid #E5E5E5",
            margin: "8px 16px",
          }}
        />
      )}
    </>
  );
}) as <T extends { id: string }>(props: ActionMenuItemProps<T>) => JSX.Element;

export default ActionMenuItem;
